import styled from 'styled-components';
import color from '../../configs/color';

const MessageWrapper = styled.div`
  background-color: ${color.white};
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 16px;
  .component_message_header {
    position: relative;
    display: flex;
    align-items: center;
    column-gap: 8px;
    margin-bottom: 16px;
    .ant-avatar {
      background-color: ${color.orange6};
      color: ${color.orange1};
      border: 1px solid ${color.grey1};
    }
    .anticon {
      position: absolute;
      right: 0;
      color: ${color.black2};
      cursor: pointer;
    }
  }
`;

export default MessageWrapper;
